export const PURGE_AUTH = 'logOut'
export const SET_AUTH = 'setUser'
export const SET_ERROR = 'setError'
export const PURGE_AUTH_CLIENT = 'logOutClient'
export const SET_AUTH_CLIENT = 'setUserClient'
export const SET_UPDATE_AUTH_CLIENT = 'updateUserClient'
export const SET_ERROR_CLIENT = 'setErrorClient'
export const OPEN_LOGIN_DIALOG = 'openLoginDialog'
export const SET_LOGIN_DIALOG_CONTEXT = 'setLoginDialogContext'
export const OPEN_REGISTER_DIALOG = 'openRegisterDialog'
export const SET_MEMBER_NEW_MESSAGE_NOTIFICATION = 'setMemberNewMessageNotification'
export const SET_ADMIN_CONVERSATION_NEW_MESSAGE = 'setAdminConversationNewMessage'
export const SET_HIDDEN_NAV_MENU = 'setHiddenNavMenu'
export const PREVIEW_FILE = 'previewFile'
export const DESTROY_FILE = 'destroyFile'
export const SET_PASSWORD_REMIND = 'setPasswordRemind'
export const SET_ROLE_PERMISSION_GROUP = 'setRolePermissionGroup'
export const PURGE_ROLE_PERMISSION_GROUP = 'clearRolePermissionGroup'
export const SET_HIDDEN_REGISTER_HEADER = 'setHiddenRegisterHeader'
export const SET_MAINTENANCE = 'setMainteance'
